var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kanban-board" },
    [
      _c(
        "draggable",
        {
          staticClass: "supsis-draggable",
          attrs: { options: _vm.taskGroupDragOptions },
          on: {
            start: function () {
              return (_vm.moving = true)
            },
            end: _vm.movePipelineEnd,
          },
          model: {
            value: _vm.groups,
            callback: function ($$v) {
              _vm.groups = $$v
            },
            expression: "groups",
          },
        },
        [
          _c(
            "transition-group",
            { staticClass: "drag-container", attrs: { tag: "div" } },
            _vm._l(_vm.groups, function (item) {
              return _c("TaskColumnCard", {
                key: item._id,
                attrs: { pipeline: item, moving: _vm.moving },
                on: {
                  moved: _vm.moveActionEnd,
                  "pipeline-form": _vm.createPipelineForm,
                  "delete-pipeline": _vm.deletePipeline,
                  "create-pipeline": _vm.createPipeline,
                  "update-pipeline": _vm.updatePipeline,
                  "delete-modal-task": _vm.openDeleteTaskModal,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.deleteTaskModal
        ? _c("DeleteModal", {
            attrs: {
              description: _vm.$t("task.deleteTaskCont"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.delete"),
            },
            on: {
              cancel: function ($event) {
                _vm.deleteTaskModal = false
              },
              confirm: _vm.softDeleteTask,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }